<template>
  <div>
    <h2 class="text-extra-extra-large text-center my-4 pb-3">
      <template>
        Create OKRs with North AI
      </template>
    </h2>
    <!-- <p class="text-center text-secondary sub-title mb-4 mx-auto">
      Ask North AI to create Objectives and Key Results - Give it context about your business and
      let it work it’s magic
    </p> -->
  </div>
</template>

<script>
export default {
  name: 'NorthAITemplatesHeader',
  props: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.sub-title {
  max-width: 500px;
}
</style>
